module.exports = __webpack_public_path__ + "webstatic/img/4.40b4b73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/v2img/4.png
// module id = CnDm
// module chunks = 3